import * as core from '../../../../../../../core'

import { query } from './suggested-engagement-actions-by-owner.query'

export const RESOURCE = {
  payload: {
    alias: 'suggested.engagement.actions.by.owner',
    description: 'View of suggested engagement actions by owner',
    name: 'Suggested Engagement Actions by Owner',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
